<div class="info-view videos-view">
  <div class="info-view-header">
    <div class="info-view-heading">
      <div class="info-view-title">Videos specifications</div>
      @if (canWrite) {
        <button
          mat-mini-fab
          color="buttonSuccess"
          class="info-view-create-button"
          matTooltip="Create videos specification"
          aria-label="Create videos specification"
          (click)="onCreateVideos()"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (loaded) {
    @if (videosSpecs.length === 0) {
      <div class="empty-state">
        No videos specifications yet. Click Create to add one.
      </div>
    } @else {
      <div class="spec-list">
        @for (row of videosSpecs; track row.id) {
          <div class="spec-list-item">
            <div class="spec-info">
              <div class="spec-name-row">
                <span class="spec-name">{{ row.name }}</span>
                <span class="range-meta">
                  <mat-icon class="mat-icon-inline">{{ metaBadge(row).icon }}</mat-icon>
                  {{ metaBadge(row).label }}
                </span>
              </div>
              <div class="spec-summary-row">
                <span class="spec-kv"><span class="k">Format</span><span class="v">{{ formatLabel(row) }}</span></span>
                <span class="spec-kv"><span class="k">Size</span><span class="v">{{ sizeLabel(row) }}</span></span>
                <span class="spec-kv"><span class="k">Bitrate</span><span class="v">{{ bitRateLabel(row) }}</span></span>
              </div>
            </div>
            <div class="row-actions">
              @if (canAudit) {
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="View change history"
                  aria-label="View change history"
                  (click)="onViewVideosHistory(row)"
                >
                  <mat-icon>history</mat-icon>
                </button>
              }
              @if (canWrite) {
                <button
                  mat-icon-button
                  color="buttonSuccess"
                  matTooltip="Update"
                  aria-label="Update videos specification"
                  (click)="onUpdateVideos(row)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Delete"
                  aria-label="Delete videos specification"
                  (click)="onDeleteVideos(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
